<category-component>
</category-component>

<div class="fixed-header-height">
    <div class="onhold-message" *ngIf="global_data?.bobby_onhold" >
        <img src="../../assets/images/wos_info_icon.svg" alt="percent-icon">
        <span class="onhold">Account On Hold. </span>
        <span *ngIf="global_data?.bobby_onhold && (global_data?.bobby_depotphone == undefined || global_data?.bobby_depotphone == '' )">You can build your basket, but checkout is disabled. Please contact your depot to remove the hold and start ordering again.</span>
        <span *ngIf="global_data?.bobby_onhold && (global_data?.bobby_depotphone != undefined && global_data?.bobby_depotphone != '' ) ">You can build your basket, but checkout is disabled. Please contact your depot on <span class="onhold">{{global_data?.bobby_depotphone}}</span> to remove the hold and start ordering again.</span>
    </div>
    <hero-slider></hero-slider>
</div>
<app-sub-banner></app-sub-banner>
<app-recommend-products-slider></app-recommend-products-slider>

<app-brands [topBrandsListing]="topBrandsListing" [brandsListing]="brandsListing"
    [headerBrandsAlphabet]="headerBrandsAlphabet" *ngIf="topBrandsListing.length"></app-brands>
<offers-slider></offers-slider>
<product-listing-slider></product-listing-slider>



<div class="grey-bg">
    <testimonial-slider></testimonial-slider>
</div>
<download-app></download-app>